// @flow

import * as React from 'react';
import moment from 'moment';
import { ISO_DAYS } from 'common/domain/DayOfWeek';
import SpecificDateRangePicker, { DateRangePickerProps } from './SpecificDateRangePicker';

const ISO_FULL_WEEK_DAYS = [
  ISO_DAYS.MONDAY,
  ISO_DAYS.TUESDAY,
  ISO_DAYS.WEDNESDAY,
  ISO_DAYS.THURSDAY,
  ISO_DAYS.FRIDAY,
  ISO_DAYS.SATURDAY,
  ISO_DAYS.SUNDAY,
];

export default function FullISOWeekPicker(props: DateRangePickerProps) {
  return (
    <SpecificDateRangePicker
      {...props}
      disabledDates={getDisabledDates(props)}
      getRange={findFullWeekFor}
      selectableISODays={ISO_FULL_WEEK_DAYS}
    />
  );
}

function getDisabledDates({ minDate, maxDate }: DateRangePickerProps) {
  const disabled = {};
  minDate && (disabled.before = minDate.clone().endOf('isoWeek').add(1, 'days').toDate());
  maxDate && (disabled.after = maxDate.clone().startOf('isoWeek').subtract(1, 'days').toDate());

  return disabled;
}

function findFullWeekFor(day: Date) {
  return {
    from: moment(day).startOf('isoWeek').toDate(),
    to: moment(day).endOf('isoWeek').startOf('day').toDate(),
  };
}



// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/FullISOWeekPicker.js